import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-play-solid",
  "use": "icon-common-play-solid-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" fill=\"none\" id=\"icon-common-play-solid\">\n  <path d=\"M3.29126 2.67537V10.6051C3.29126 11.0819 3.7561 11.3849 4.13892 11.1563L10.9174 7.09932C11.2488 6.90108 11.2488 6.37936 10.9174 6.18112L4.13892 2.12412C3.7561 1.89553 3.29126 2.1985 3.29126 2.67537Z\" fill=\"#1D1D1D\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-miterlimit=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol